import { Provider } from '@angular/core';

import { PowerBiService } from '@app/power-bi/services/power-bi.service';
import { PowerBIEmbedService } from '@power-bi/services/power-bi-embed.service';
import { PowerBIExportReportService } from '@power-bi/services/power-bi-export-report.service';

export const POWER_BI_PROVIDERS: Provider[] = [
  PowerBiService,
  PowerBIEmbedService,
  PowerBIExportReportService
];
